import { FlashType } from 'modules/core/store/models/app'
import app from 'modules/core/store/models/app'

interface Options {
  progressMessage: string
  successMessage: string
  successFlashType?: FlashType
  closePortal?: () => void
}

/**
 * Returns helpers to manage progress/flash feedback for shift mutations
 * that can be triggered either from a sidepanel (closePortal provided)
 * or from the grid (no closePortal → progress toast).
 *
 * Usage:
 *   const { startFeedback, onSuccess, onError } = shiftMutationFeedback({ ... })
 *   startFeedback()
 *   // ... await mutation ...
 *   if (handled.success) await onSuccess()
 *   else onError()
 */
export const shiftMutationFeedback = ({
  progressMessage,
  successMessage,
  successFlashType = 'correct',
  closePortal,
}: Options) => {
  const startFeedback = () => {
    if (!closePortal) {
      app.setProgress({ message: progressMessage })
    }
  }

  const onSuccess = async () => {
    if (closePortal) {
      closePortal()
    } else {
      app.setProgress(null)
      await Promise.resolve()
    }
    app.setFlash({ type: successFlashType, message: successMessage })
  }

  const onError = () => {
    if (!closePortal) {
      app.setProgress(null)
    }
  }

  return { startFeedback, onSuccess, onError }
}
